import { apiUrl } from './platform'

const MAX_RETRIES = 2
const INITIAL_DELAY_MS = 1000

function isRetryable(status) {
  return status === 429 || status >= 500
}

function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

/**
 * Calls the server-side API to manage class schedules via chat.
 * Returns { type: 'classes'|'question', classes: [...]|null, message: '...', action: '...', deleteIds: [...] }
 */
export async function chatClassSchedule({ userMessage, classes, chatHistory }) {
  let lastError

  for (let attempt = 0; attempt <= MAX_RETRIES; attempt++) {
    if (attempt > 0) {
      await delay(INITIAL_DELAY_MS * attempt)
    }

    const response = await fetch(apiUrl('/api/chat-class-schedule'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userMessage, classes, chatHistory }),
    })

    if (!response.ok) {
      const err = await response.json().catch(() => ({}))
      lastError = new Error(err.error || `API error: ${response.status}`)
      lastError.status = response.status

      if (isRetryable(response.status) && attempt < MAX_RETRIES) {
        continue
      }
      throw lastError
    }

    const data = await response.json()

    if (!data || !data.type || !data.message) {
      throw new Error('Invalid response from AI')
    }

    return data
  }

  throw lastError
}
